import cipherFormComponents from "../../../web-sh/src/components/cipher/form";

import PasswordForm from "./Password";

cipherFormComponents.PasswordForm = PasswordForm;

export default cipherFormComponents;